export default __webpack_public_path__ + "static/Autos2050_Logo_Small-d44aed6241f52def89ae37438f4d979f.png";